import {Box} from '@indoqa/style-system'
import {IStyle} from 'fela'
import {useFela} from 'react-fela'
import {Theme} from '../../../app/theme'
import {ArLink} from '../links/ArLink'

interface Props {
  name: string
  link: string
  onClick?: () => void
}

export function ArTopicTile({name, link, onClick}: Props) {
  const {theme} = useFela<Theme>()

  // Let the anchor fill the tile so the whole grey area is clickable, not just the text.
  const tileStyle: IStyle = {
    height: '100%',
    '& a': {
      display: 'block',
      padding: theme.spacing.space3,
      textAlign: 'center',
      textDecoration: 'none',
    },
  }

  return (
    <Box bg="bgContentEmphasised" r={8} cursorPointer style={tileStyle}>
      <ArLink name={name} link={link} underline={false} color={theme.colors.text} onClick={onClick} />
    </Box>
  )
}
